import { Container } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { FC, ReactNode } from 'react';

import { FontFamily } from '@/enums/index';
import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

const ContentWrapper = styled('div')<IThemeProps>`
  margin: 0 auto;
  font-family: ${({ theme }) => theme.legacy.typography.fontFamily[FontFamily.IBMPlexSerif]};
  font-size: 16px;
  line-height: 24px;
  color: black;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    font-size: 20px;
    line-height: 32px;
  }

  p {
    @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
      margin: 40px 0;
    }
  }

  em {
    color: ${({ theme }) => theme.legacy.colors.lightText};
    font-size: 20px;
    line-height: 32px;

    @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
      font-size: 24px;
      line-height: 40px;
    }
  }
`;

interface IContentProps {
  children: ReactNode;
}

export const Content: FC<IContentProps> = ({ children }) => (
  <Container>
    <ContentWrapper>{children}</ContentWrapper>
  </Container>
);
